var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var createMuiAlertTitleOverrides = function (_a) {
    var typography = _a.typography, spacing = _a.spacing;
    return {
        styleOverrides: {
            root: __assign(__assign({}, typography.subtitle2), { display: 'inline', marginRight: spacing(0.5) }),
        },
    };
};
